import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Input, Typography } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import HotSwapDatePicker from './hot-swap-date-picker'
import { useQuery } from 'react-query'
import { getHotswapWeeks } from '../api/hotswaps-api'
import CustomButton from '../../root/components/common/button'
import usePatchHotSwapWeeks from '../api/usePatchHotSwapWeeks'

export default function HotSwapTabCapacity() {
    const classes = useStyles()

    const { data, isLoading, refetch } = useQuery([], () => getHotswapWeeks(7))
    const [weeks, setWeeks] = useState([])

    const hotSwapWeeksMutation = usePatchHotSwapWeeks()

    useEffect(() => {
        if (data) {
            setWeeks(data)
        }
    }, [data])

    const onChangeCapacity = (id, e) => {
        setWeeks(
            weeks.map(w => {
                if (w.id === id) {
                    return { ...w, capacity: e.target.value, isChanged: true }
                }

                return w
            })
        )
    }

    const onSaveClick = () => {
        const payload = weeks
            .filter(w => w.isChanged)
            .map(w => ({ id: w.id, capacity: Number(w.capacity) }))

        hotSwapWeeksMutation.mutate(payload, {
            onSuccess: () => refetch()
        })
    }

    return (
        <>
            {!isLoading && (
                <div className={classes.calendarDiv}>
                    <div>
                        <TableContainer className={classes.tableContainer}>
                            <Table>
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                        <TableCell>Calendar Week</TableCell>
                                        <TableCell>Booked</TableCell>
                                        <TableCell>Current Capacity</TableCell>
                                        <TableCell>Remaining</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {weeks.map(item => (
                                        <TableRow key={item.id}>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    <span
                                                        className={
                                                            classes.boldText
                                                        }
                                                    >
                                                        {item.week}
                                                    </span>
                                                    ({item.interval})
                                                </Typography>
                                            </TableCell>
                                            <TableCell
                                                className={classes.greenText}
                                            >
                                                {item.booked}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Input
                                                    className={
                                                        classes.borderedBox
                                                    }
                                                    disableUnderline={true}
                                                    value={item.capacity}
                                                    onChange={e =>
                                                        onChangeCapacity(
                                                            item.id,
                                                            e
                                                        )
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {item.remaining}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <CustomButton
                                className={classes.btn}
                                onClick={onSaveClick}
                            >
                                Save
                            </CustomButton>
                        </TableContainer>
                    </div>
                    <div className={classes.date}>
                        <HotSwapDatePicker
                            onDateChange={value => console.log(value)}
                        />
                        <Typography></Typography>
                    </div>
                </div>
            )}
        </>
    )
}

const useStyles = makeStyles(() => ({
    tableContainer: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        width: '100%',
        marginTop: '30px'
    },
    tableHead: {
        backgroundColor: '#f5f5f5'
    },
    greenText: {
        color: 'green'
    },
    calendarDiv: {
        display: 'flex',
        width: '100%'
    },
    date: {
        marginLeft: '50px',
        marginTop: '30px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    borderedBox: {
        border: '1px solid #000',
        padding: '8px',
        display: 'inline-block',
        borderRadius: '12px',
        width: '80%'
    },
    btn: {
        display: 'flex',
        marginTop: '10px'
    }
}))
